.fd{width:max-content;}